import React from "react";
import { ContactForm } from "../Components/Contact/ContactForm";

const Contact = () => {
	return <ContactForm />;
};

export default Contact;
